// extracted by mini-css-extract-plugin
module.exports = {"followBtn":"style_followBtn__1vmwJ"};